<div class="form" [formGroup]="form">
  <nx-edit-multiselect-input
    [showLabel]="true"
    formControlName="selected"
    [filter]="true"
    [options]="options"
    [panelWidhtFull]="true"
    [placeholder]="placeholder()"
    [label]="label()">
  </nx-edit-multiselect-input>

</div>
